import { useEffect, useState, useCallback } from "react";
import { Sparkles, Loader2, FileText } from "lucide-react";
import { api, formatApiError } from "../context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

export default function RapportDialog({ open, onOpenChange, canGenerate }) {
  const [rapports, setRapports] = useState([]);
  const [selected, setSelected] = useState(null);
  const [generating, setGenerating] = useState(false);

  const load = useCallback(() => {
    api.get("/rapports").then((r) => {
      setRapports(r.data.rapports);
      if (r.data.rapports.length && !selected) setSelected(r.data.rapports[0]);
    }).catch((e) => toast.error(formatApiError(e)));
  }, [selected]);

  useEffect(() => { if (open) load(); }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const generate = async () => {
    setGenerating(true);
    try {
      const { data } = await api.post("/rapports/synthese");
      toast.success("Synthèse générée par Claude");
      setSelected(data);
      load();
    } catch (e) {
      toast.error(formatApiError(e, "Échec de la génération"));
    } finally {
      setGenerating(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl" data-testid="rapport-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Sparkles className="h-5 w-5 text-accent" /> Synthèse IA des certifications</DialogTitle>
          <DialogDescription>Générée par Claude Sonnet 5 à partir des données en temps réel. Une synthèse est aussi envoyée par email le 1er de chaque mois.</DialogDescription>
        </DialogHeader>
        {canGenerate && (
          <Button onClick={generate} disabled={generating} className="w-fit" data-testid="generate-rapport-button">
            {generating ? <><Loader2 className="h-4 w-4 mr-2 animate-spin" /> Génération en cours (10-20 s)...</> : <><Sparkles className="h-4 w-4 mr-2" /> Générer une nouvelle synthèse</>}
          </Button>
        )}
        {rapports.length > 0 && (
          <div className="flex flex-wrap gap-1.5">
            {rapports.map((r) => (
              <button key={r.id} onClick={() => setSelected(r)} data-testid={`rapport-tab-${r.id}`}
                className={`text-xs font-mono rounded-full px-3 py-1 border transition-colors ${selected?.id === r.id ? "bg-primary/15 text-primary border-primary/50" : "border-border text-muted-foreground hover:bg-secondary"}`}>
                {r.created_at?.slice(0, 16).replace("T", " ")}
              </button>
            ))}
          </div>
        )}
        <div className="rounded-lg border border-border bg-background p-4 max-h-96 overflow-y-auto" data-testid="rapport-content">
          {selected ? (
            <p className="text-sm whitespace-pre-wrap leading-relaxed">{selected.contenu}</p>
          ) : (
            <p className="text-sm text-muted-foreground flex items-center gap-2"><FileText className="h-4 w-4" /> Aucune synthèse pour le moment. Cliquez sur « Générer ».</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
